import { useCallback, useEffect, useRef, useState } from 'react';
/** A completion belongs to the latest gesture and only while its control exists. */
export function useCopyFeedback(write, onError, duration = 1500) {
    const [state, setState] = useState('idle');
    const attempt = useRef(0);
    const timer = useRef();
    useEffect(() => () => { attempt.current += 1; clearTimeout(timer.current); }, []);
    const copy = useCallback(async () => {
        const current = ++attempt.current;
        clearTimeout(timer.current);
        setState('idle');
        try {
            await write();
            if (attempt.current !== current)
                return;
            setState('copied');
        }
        catch (error) {
            if (attempt.current !== current)
                return;
            setState('failed');
            onError?.(error);
        }
        finally {
            if (attempt.current === current)
                timer.current = setTimeout(() => {
                    if (attempt.current === current)
                        setState('idle');
                }, duration);
        }
    }, [write, onError, duration]);
    return { copy, copied: state === 'copied', failed: state === 'failed' };
}
//# sourceMappingURL=useCopyFeedback.js.map